const data = [
  {
    id: "home",
    icon: "simple-icon-home",
    label: "صفحه اصلی",
    to: "/",
    roles: [
      "Admin",
      "AdminSupport",
      "TransportationCompanyAdmin",
      "TransportationCompany",
      "LoadHallAdmin",
      "Organization",
      "DriversAssociation",
      "AssociationTransportCompanies",
      "ProductOwnerAdmin",
      "Driver",
    ],
    access_code: null,
  },
  {
    id: "home",
    icon: "simple-icon-home",
    label: "پروفایل",
    to: "/Profile",
    roles: "Driver",
    access_code: null,
  },
  {
    id: "manage-loads",
    icon: "simple-icon-people",
    label: "بارها",
    to: "/app/manage-loads",
    roles: ["Admin", "AdminSupport"],
    access_code: null,

    subs: [
      {
        icon: "iconsminds-file-clipboard-file---text",
        label: "بارهای اعلام شده",
        to: "/AdminCargos",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
      {
        icon: "iconsminds-file-clipboard-file---text",
        label: "بارهای انتخاب شده",
        to: "/AdminDriverReserve",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
    ],
  },
  {
    id: "manage-drivers",
    icon: "iconsminds-support",
    label: "رانندگان",
    to: "/app/manage-drivers",
    roles: ["Admin", "AdminSupport"],
    access_code: null,

    subs: [
      {
        icon: "iconsminds-magnifi-glass",
        label: "جستجوی راننده",
        to: "/Driver/Drivers",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
      //{
      //  icon: "iconsminds-folder-block",
      //  label: "رانندگان غیرفعال",
      //  to: "/Admin/Driver/InActive",
      //  roles: [
      //    "Admin",
      //    "AdminSupport"
      //  ],
      //  access_code: null
      //  },
      {
        icon: "iconsminds-folder-block",
        label: "افزودن راننده جديد",
        to: "/Driver/AddDriver",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
    ],
  },
  {
    icon: "iconsminds-business-mens",
    label: " صاحبان کالا",
    to: "/ManageProductOwner",
    roles: ["Admin"],
    access_code: null,
  },
  {
    id: "manage-transportationcompanys",
    icon: "simple-icon-organization",
    label: "شركت حمل ونقل",
    to: "/TransportationCompany",
    roles: ["Admin"],
    access_code: null,
  },

  {
    id: "admincomments",
    icon: "iconsminds-megaphone",
    label: "رسیدگی به شکایات",
    to: "/app/admincomments",
    roles: ["Admin"],
    access_code: null,

    subs: [
      {
        id: "admincomments-subs",
        label: "رسیدگی به شکایات",
        to: "/admincomments",
        roles: ["Admin"],
        access_code: null,
        subs: [
          {
            icon: "simple-icon-note",
            label: "رسیدگی به شکایات",
            to: "/admincomment",
            roles: ["Admin"],
            access_code: "access_Cargo_Add",
          },
        ],
      },
    ],
  },
  {
    id: "loads",
    icon: "iconsminds-megaphone",
    label: "بار ها",
    to: "/app/loads",
    roles: [
      "TransportationCompanyAdmin",
      "TransportationCompanyMember",
      "ProductOwnerAdmin",
      "Driver",
    ],
    access_code: null,

    subs: [
      {
        id: "loads-subs",
        label: "اعلام بار",
        to: "/loads",
        roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin", "Driver"],
        access_code: null,
        subs: [
          {
            icon: "simple-icon-note",
            label: "اعلام بار جدید",
            to: "/AddCargo",
            roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
            access_code: "access_Cargo_Add",
          },
          {
            icon: "iconsminds-notepad",
            label: "بارهای اعلام شده",
            to: "/Cargos",
            roles: [
              "TransportationCompanyAdmin",
              "Driver",
              "ProductOwnerAdmin",
            ],
            access_code: "access_Load_Manage",
          },
          {
            icon: "iconsminds-notepad",
            label: "بارهای انتخاب شده",
            to: "/DriverReserves",
            roles: [
              "TransportationCompanyAdmin",
              "Driver",
              "ProductOwnerAdmin",
            ],
            access_code: "access_Reserve_List",
          },
        ],
      },
    ],
  },

  //    Admin
  // {
  //   id: "information-basic",
  //   icon: "iconsminds-book",
  //   label: "اطلاعات پایه",
  //   to: "/app/info-plus",
  //   roles: [
  //     "TransportationCompanyAdmin",
  //     "TransportationCompanyMember"
  //   ],
  //   access_code: null,

  //   subs: [
  //     {
  //       id: "info-lists",
  //       label: "مدیریت",
  //       to: "/lists",
  //       roles: [
  //         "TransportationCompanyAdmin"
  //       ],
  //       access_code: null,

  //       subs: [
  //         {
  //           icon: "simple-icon-people",
  //           label: "مدیریت مشتریان",
  //           to: "/Customer",
  //           roles: [
  //             "TransportationCompanyAdmin"
  //           ],
  //           access_code: "access_Customer_List"
  //         },
  //       ]
  //     },
  //   ]
  // },
  // {
  //   id: "estelaam",
  //   icon: "iconsminds-laptop-secure\n",
  //   label: "استعلام",
  //   to: "/app/estelaam",
  //   roles: [
  //     "Customer",
  //     "TransportationCompanyMember",
  //     "TransportationCompanyAdmin"
  //   ],
  //   access_code: null,

  //   subs: [
  //     {
  //       icon: "iconsminds-id-card",
  //       label: "استعلام اطلاعات پایه",
  //       to: "/Estelam",
  //       roles: [
  //         "Customer",
  //         "TransportationCompanyMember",
  //         "TransportationCompanyAdmin"
  //       ],
  //       access_code: null
  //     },
  //     {
  //       icon: "iconsminds-id-card",
  //       label: "استعلام آخرین بارنامه ناوگان (شماره ملی)",
  //       to: "/LastBillSearch",
  //       roles: [
  //         "Customer",
  //         "TransportationCompanyMember",
  //         "TransportationCompanyAdmin"
  //       ],
  //       access_code: null
  //     },
  //     {
  //       icon: "iconsminds-id-card",
  //       label: "استعلام آخرین بارنامه ناوگان (شماره هوشمند)",
  //       to: "/LastBazargahBillSearch",
  //       roles: [
  //         "Customer",
  //         "TransportationCompanyMember",
  //         "TransportationCompanyAdmin"
  //       ],
  //       access_code: null
  //     }
  //   ]
  // },
  {
    id: "reports",
    icon: "simple-icon-chart",
    label: "گزارشات",
    to: "/app/reports",
    roles: [
      "Organization",
      "DriversAssociation",
      "AssociationTransportCompanies",
    ],
    access_code: null,

    subs: [
      {
        icon: "simple-icon-people",
        label: "گزارش کلی",
        to: "/FullReport",
        roles: [
          "TransportationCompanyMember",
          "TransportationCompanyAdmin",
          "AgentMain",
        ],
        access_code: null,
      },
      {
        id: "info-lists",
        label: "گزارشات پیش‌فرض",
        to: "/lists",
        icon: "iconsminds-optimization",
        roles: [
          "TransportationCompanyMember",
          "TransportationCompanyAdmin",
          "AgentMain",
        ],
        access_code: null,

        subs: [
          {
            icon: "iconsminds-mail-money",
            label: "بارنامه - مالی",
            to: "/MaliReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-billing",
            label: "بارنامه - حسابداری",
            to: "/HesabdariReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-billing",
            label: "گزارش - حسابداری داخلی",
            to: "/HesabdarInternalReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-affiliate",
            label: "بارنامه - فرستنده و گیرنده",
            to: "/FrestandeGirandeReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-diploma-2",
            label: "بارنامه - بیمه",
            to: "/BimehReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-hotel",
            label: "بارنامه - سازمان",
            to: "/SazmanReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-router",
            label: "بارنامه - صورت وضعیت",
            to: "/SuratVaziatReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-mens",
            label: "عملکرد رانندگان",
            to: "/amalkerd-report",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-receipt-4",
            label: "گزارش پرداخت بارنامه",
            to: "/BillOfLadingPaymentReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
              "AgentMain",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-file-clipboard-file---text",
            label: "گزارش نهاده دامی",
            to: "/BillWithUniqueCode",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
            ],
            access_code: null,
          },
          {
            icon: "iconsminds-box-with-folders",
            label: "گزارش - بارنامه",
            to: "/BillListReport",
            roles: [
              "TransportationCompanyMember",
              "TransportationCompanyAdmin",
            ],
            access_code: null,
          },
        ],
      },

      //  Admin
      // {
      //   icon: "iconsminds-new-mail",
      //   label: "گزارش رزروها",
      //   to: "/Admin/Report/ReservesList",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
      // {
      //   icon: "iconsminds-mail-money",
      //   label: "گزارش مالی رزروها",
      //   to: "/Admin/Report/DriverReservesReport",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
      // {
      //   icon: "iconsminds-billing",
      //   label: "گزارش پرداخت بارنامه",
      //   to: "/BillOfLadingPaymentReport",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
      // {
      //   icon: "iconsminds-fax",
      //   label: "گزارش حواله‌ها",
      //   to: "/Draft/List",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: "access_Draft_List"
      // },
      // {
      //   icon: "iconsminds-inbox-full",
      //   label: "گزارش بارنامه‌ها",
      //   to: "/Bill/List",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
      // {
      //   icon: "iconsminds-mail-unread",
      //   label: "گزارش بیشترین رزرو",
      //   to: "/Admin/Report/HighestDriverReserves",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },

      // {
      //   icon: "iconsminds-wallet",
      //   label: "گزارش کیف پول",
      //   to: "/Admin/Report/AccountActivityReport",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
      // {
      //   icon: "iconsminds-check",
      //   label: "گزارش اعلام حضور",
      //   to: "/DriverAnnounceSearch",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
      // {
      //   icon: "iconsminds-mail-3",
      //   label: "گزارش بن رانندگان",
      //   to: "/Admin/Report/DriverStock",
      //   roles: [
      //     "Admin",
      //     "AdminSupport",
      //   ],
      //   access_code: null
      // },
    ],
  },
  // {
  //   id: "driver-scores",
  //   icon: "simple-icon-star",
  //   label: "امتیاز رانندگان",
  //   to: "/app/driver-scores",
  //   roles: [
  //     "Admin",
  //     "AdminSupport"
  //   ],
  //   access_code: null,

  //   subs: [
  //     {
  //       icon: "iconsminds-magnifi-glass",
  //       label: "جستجو",
  //       to: "/Admin/DriverRating/Search",
  //       roles: [
  //         "Admin",
  //         "AdminSupport"
  //       ],
  //       access_code: null
  //     },
  //     {
  //       icon: "iconsminds-bar-chart-4",
  //       label: "رانندگان برتر",
  //       to: "/Admin/DriverRating/Top",
  //       roles: [
  //         "Admin",
  //         "AdminSupport"
  //       ],
  //       access_code: null
  //     }
  //]
  // },
  // {
  //   id: "Ads",
  //   icon: "iconsminds-digital-drawing",
  //   label: "مدیریت تبلیغات",
  //   to: "/Admin/Ads",
  //   roles: [
  //     "Admin"
  //   ],
  //   access_code: null
  // },
  // {
  //   id: "contact-setting",
  //   icon: "iconsminds-telephone-2",
  //   label: "تغییر اطلاعات تماس",
  //   to: "/Admin/Settings/Contact",
  //   roles: [
  //     "Admin"
  //   ],
  //   access_code: null
  // },

  //     {
  //       icon: "iconsminds-male-female",
  //       label: "مدیریت کاربران",
  //       to: "/ManageUser",
  //       roles: [
  //         "TransportationCompanyAdmin"
  //       ],
  //       access_code: null
  //     },

  //   //    Admin
  //     {
  //       icon: "iconsminds-add-user",
  //       label: "افزودن کاربر جدید",
  //       to: "/User",
  //       roles: [
  //         "Admin"
  //       ],
  //       access_code: null
  //     },
  //     {
  //       icon: "iconsminds-male-female",
  //       label: "مدیریت کاربران",
  //       to: "/AdminManageUser",
  //       roles: [
  //         "Admin"
  //       ],
  //       access_code: null
  //     }
  //   ]
  // },
  // {
  //   id: "manage-wallet",
  //   icon: "simple-icon-wallet",
  //   label: "مدیریت کیف پول",
  //   to: "/app/manage-wallet",
  //   roles: [
  //     "TransportationCompanyAdmin",
  //     "VirtualSalon",
  //     "Admin",
  //     "AdminSupport"
  //   ],
  //   access_code: null,

  //   subs: [
  //     //{
  //     //  icon: "iconsminds-mail-money",
  //     //  label: "لیست تراکنش‌ها",
  //     //  to: "/AccountActivities",
  //     //  roles: [
  //     //    "TransportationCompanyAdmin",

  //     //  ],
  //     //  access_code: null
  //     //},
  ////     {
  ////       icon: "iconsminds-key-lock",
  ////       label: "دسترسی برداشت وجه",
  ////       to: "/Admin/WithdrawAccess",
  ////       roles: [
  ////         "Admin"
  ////       ],
  ////       access_code: null
  ////     },
  ////     {
  ////       icon: "iconsminds-notepad",
  ////       label: "مدیریت اطلاعات برداشت",
  ////       to: "/FinnotechInfo",
  ////       roles: [
  ////         "Admin"
  ////       ],
  ////       access_code: null
  ////     },
  ////     {
  ////       icon: "iconsminds-yes",
  ////       label: "درخواست انتقال وجه",
  ////       to: "/MoneyTransferRequest",
  ////       roles: [
  ////         "Admin"
  ////       ],
  ////       access_code: null
  ////     },
  ////     {
  ////       icon: "iconsminds-security-check",
  ////       label: "تایید انتقال",
  ////       to: "/AcceptTransfer",
  ////       roles: [
  ////         "Admin"
  ////       ],
  ////       access_code: null
  ////     },
  ////     {
  ////       icon: "iconsminds-file-clipboard-file---text",
  ////       label: "لیست تراکنش‌های انتقال داده‌شده",
  ////       to: "/AcceptedTransfer",
  ////       roles: [
  ////         "Admin"
  ////       ],
  ////       access_code: null
  ////     },
  //     {
  //       icon: "iconsminds-coins",
  //       label: "شارژ آنلاین",
  //       to: "/OnlineCharge",
  //       roles: [
  //         "TransportationCompanyAdmin"
  //       ],
  //       access_code: null
  //       },

  ////     {
  ////       icon: "iconsminds-wallet",
  ////       label: "مدیریت حساب بانکی",
  ////       to: "/AccountMember",
  ////       roles: [
  ////         "TransportationCompanyAdmin",
  ////         "VirtualSalon",
  ////       ],
  ////       access_code: null
  ////     }
  //   ]
  // },

  // {
  //   id: "ProductOwners",
  //   icon: "iconsminds-profile",
  //   label: "مدیریت صاحبان کالا",
  //   to: "/Admin/ProductOwners",
  //   roles: [
  //     "Admin"
  //   ],
  //   access_code: null
  // },
  // {
  //   id: "manage-customers",
  //   icon: "simple-icon-people",
  //   label: "مدیریت مشتریان",
  //   to: "/app/manage-customers",
  //   roles: [
  //     "Admin",
  //     "AdminSupport"
  //   ],
  //   access_code: null,

  //   subs: [
  //     {
  //       icon: "simple-icon-user-follow",
  //       label: "افزودن مشتری جدید",
  //       to: "/Admin/Customer/Add",
  //       roles: [
  //         "Admin",
  //         "AdminSupport"
  //       ],
  //       access_code: null
  //     },
  //     {
  //       icon: "iconsminds-notepad",
  //       label: "مدیریت مشتریان",
  //       to: "/Admin/Customer",
  //       roles: [
  //         "Admin",
  //         "AdminSupport"
  //       ],
  //       access_code: null
  //     }
  //   ]
  // },

  // {
  //   id: "manage-comments",
  //   icon: "simple-icon-speech",
  //   label: "مدیریت نظرات",
  //   to: "/app/manage-comments",
  //   roles: [
  //     "Admin",
  //     "AdminSupport"
  //   ],
  //   access_code: null,

  //   subs: [
  //     {
  //       icon: "iconsminds-speach-bubble-comic-2",
  //       label: "لیست نظرات رانندگان",
  //       to: "/Admin/DriverSurvey",
  //       roles: [
  //         "Admin",
  //         "AdminSupport"
  //       ],
  //       access_code: null
  //     },
  //     {
  //       icon: "iconsminds-speach-bubble-comic-2",
  //       label: "لیست پیام رانندگان",
  //       to: "/Admin/DriverSurveyDriverToAdmin",
  //       roles: [
  //         "Admin",
  //         "AdminSupport"
  //       ],
  //       access_code: null
  //     }
  //   ]
  // },

  {
    id: "LoadHallCargo",
    icon: "iconsminds-notepad",
    label: "اعلام بار",
    to: "/LoadHallCargo",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },
  {
    id: "LoadHallReserve",
    icon: "iconsminds-fax",
    label: "رزرو رانندگان",
    to: "/LoadHallReserve",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },

  // {
  //   id: "manage-notifications",
  //   icon: "simple-icon-bell",
  //   label: "مدیریت پیام‌ها",
  //   to: "/app/manage-notifications",
  //   roles: [
  //     "Admin"
  //   ],
  //   access_code: null,

  //   subs: [
  //     {
  //       icon: "iconsminds-bell",
  //       label: "پیام‌ها",
  //       to: "/Notifications",
  //       roles: [
  //         "Admin"
  //       ],
  //       access_code: null
  //     },
  //     // {
  //     //   icon: "iconsminds-speach-bubbles",
  //     //   label: "ارسال پیام",
  //     //   to: "/DriverNotification",
  //     //   roles: [
  //     //     "Admin"
  //     //   ],
  //     //   access_code: null
  //     // }
  //   ]
  // },
  // {
  //   id: "notifications",
  //   icon: "simple-icon-bell",
  //   label: "پیام‌ها",
  //   to: "/Notifications",
  //   roles: [
  //     "TransportationCompanyMember",
  //     "TransportationCompanyAdmin",
  //     "VirtualSalon"
  //   ],
  //   access_code: null
  // }
  {
    id: "loads",
    icon: "iconsminds-megaphone",
    label: "بار ها",
    to: "/app/loads",
    roles: [
      "Organization",
      "DriversAssociation",
      "AssociationTransportCompanies",
    ],
    access_code: null,

    subs: [
      {
        id: "loads-subs",
        label: "اعلام بار",
        to: "/loads",
        roles: [
          "Organization",
          "DriversAssociation",
          "AssociationTransportCompanies",
        ],
        access_code: null,
        subs: [
          {
            icon: "iconsminds-notepad",
            label: "بارهای اعلام شده",
            to: "/CargosUsers",
            roles: [
              "Organization",
              "DriversAssociation",
              "AssociationTransportCompanies",
            ],
            access_code: "access_Load_Manage",
          },
          {
            icon: "iconsminds-notepad",
            label: "بارهای انتخاب شده",
            to: "/DriverReservesUsers",
            roles: [
              "Organization",
              "DriversAssociation",
              "AssociationTransportCompanies",
            ],
            access_code: "access_Reserve_List",
          },
        ],
      },
    ],
  },
  {
    id: "comments",
    icon: "iconsminds-megaphone",
    label: "رسیدگی به شکایات",
    to: "/app/comments",
    roles: [
      "TransportationCompanyAdmin",
      "TransportationCompanyMember",
      "Driver",
      "ProductOwnerAdmin",
    ],
    access_code: null,

    subs: [
      {
        id: "comments-subs",
        label: "شکایات",
        to: "/comments",
        roles: ["TransportationCompanyAdmin", "Driver", "ProductOwnerAdmin"],
        access_code: null,
        subs: [
          {
            icon: "simple-icon-note",
            label: "رسیدگی به شکایات",
            to: "/comment",
            roles: [
              "TransportationCompanyAdmin",
              "Driver",
              "ProductOwnerAdmin",
            ],
            access_code: "access_Cargo_Add",
          },
        ],
      },
    ],
  },
  {
    id: "support",
    icon: "iconsminds-megaphone",
    label: "پشتیبانی",
    to: "/support",
    roles: "all",
    access_code: null,
  },
];

export default data;
